import { T } from "../../../util/t";
import { Typography } from "@mui/material";
import { DialogSectionLayout } from "./DialogSectionLayout";

export const DialogSection = ({ title, action, fields, className }) =>
    <DialogSectionLayout title={title} action={action} className={className}>
        {fields.map(field =>
            <p key={field.uuid || field.label}>
                <Typography variant="label1"><T>{field.label}</T>:</Typography> {field.value}
            </p>
        )}
    </DialogSectionLayout>;
